<template>
  <div class="block relative py-24 sm:py-48">
    <div class="container xxl:px-24">
      <h2 v-if="component.title" class="text-center mb-32 md:mb-56">
        {{ component.title }}
      </h2>
      <div class="mx-auto md:flex lg:w-2/3">
        <div class="w-full md:w-1/2 h-380 md:h-auto relative">
          <nuxt-img
            v-if="component.image"
            :src="component.image"
            preset="standard"
            sizes="mob375:100vw mob390:100vw mob414:100vw desk:424px"
            alt="Listningsbild"
            class="object-center object-cover w-full h-full md:absolute md:top-0 md:left-0"
            :class="
              component.backgroundPosition === 'left' ? 'md:pl-12' : 'md:pr-12'
            "
          />
        </div>
        <div
          :class="{
            'md:order-first md:pr-12': component.backgroundPosition === 'left',
            'md:pl-12': component.backgroundPosition !== 'left',
          }"
          class="w-full md:w-1/2"
        >
          <div class="mx-auto">
            <div
              v-for="(listItem, index) in component.numberList"
              :key="listItem.id"
              class="flex items-start border-b border-border py-28 md:first:border-t"
            >
              <div
                class="bg-green-25 rounded-full h-48 w-48 md:h-64 md:w-64 font-medium text-2xl md:text-3xl block flex items-center justify-center text-green-75 flex-shrink-0"
              >
                {{ (index += 1) }}
              </div>
              <div class="pl-28">
                <h4 class="mb-8">{{ listItem.title }}</h4>
                <p class="text-sm md:text-base text-black-75">
                  {{ listItem.content }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentBlock from '~/models/component-block';

import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    component: {
      type: ComponentBlock,
      required: true,
    },
  },
});
</script>
